module.exports = __webpack_public_path__ + "img/bs.6fe877e1.svg";